var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgNoComment = function SvgNoComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 269
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 29)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fillOpacity: 0.04,
    fill: "#000",
    cx: 118.5,
    cy: 199.5,
    rx: 80.5,
    ry: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.348 142.089l27.914 8.204-7.326-24.701C232.16 115.695 237 103.582 237 90.5c0-33.413-31.564-60.5-70.5-60.5S96 57.087 96 90.5s31.564 60.5 70.5 60.5c13.506 0 26.125-3.26 36.848-8.911z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.652 112.089l-27.914 8.204 7.326-24.701C4.84 85.695 0 73.582 0 60.5 0 27.087 31.564 0 70.5 0S141 27.087 141 60.5 109.436 121 70.5 121c-13.506 0-26.125-3.26-36.848-8.911zM47 68.5a8 8 0 100-16 8 8 0 000 16zm24 0a8 8 0 100-16 8 8 0 000 16zm24 0a8 8 0 100-16 8 8 0 000 16z",
    fill: "#E7E7E7"
  }))));
};
export default SvgNoComment;